// Note: The first file of a module here, must also register the module

import "./survey-answers.component";
import "./survey-details-form.component";
import "./survey-info.component";
import "./survey-list.component";
import "./survey-lists.component";
import "./survey-question-form.component";
import "./survey-result-list.component";
import "./survey-results.component";
import "./survey-results-section.component";
